module.exports = __webpack_public_path__ + "img/2.d84c5758.png";